import {
  BarChart3,
  Receipt,
  Users2,
  Truck,
  ChefHat,
  Coins,
  Boxes,
  FileText,
  TrendingUp,
  Building2,
  CircleDollarSign,
  Scale,
  Landmark,
  Banknote,
  BookOpen,
  ScrollText,
  MapPin,
  PackageOpen,
  ClipboardList,
  Clock,
  ShoppingBag,
  Percent,
  LayoutDashboard,
  AlertTriangle,
  Wallet,
} from "lucide-react";

export const REPORT_CATEGORIES = ["All", "Sales", "Customers", "Suppliers", "Operations", "Accounting", "Inventory", "MIS"];

export const REPORT_CENTER_ITEMS = [
  { id: "mis", label: "MIS Hub", category: "MIS", icon: LayoutDashboard, path: "/reports/mis" },
  { id: "mis-profit", label: "Profit Summary", category: "MIS", icon: TrendingUp, path: "/reports/mis" },
  { id: "mis-fast", label: "Fast Movers", category: "MIS", icon: TrendingUp, path: "/reports/top-items" },
  { id: "mis-below-cost", label: "Below Cost", category: "MIS", icon: AlertTriangle, path: "/reports/mis" },
  { id: "mis-vat", label: "VAT Computing", category: "MIS", icon: CircleDollarSign, path: "/reports/tax" },
  { id: "mis-fund-flow", label: "Fund Flow", category: "MIS", icon: Wallet, path: "/reports/mis" },
  { id: "daily-sales", label: "Daily Sales Summary", category: "Sales", icon: BarChart3, path: "/reports/daily-sales" },
  { id: "counter-sales", label: "Counter Sales", category: "Sales", icon: Receipt, path: "/reports/counter-sales" },
  { id: "item-sales", label: "Item Wise Sales", category: "Sales", icon: Boxes, path: "/reports/item-sales" },
  { id: "tax", label: "Tax / VAT Summary", category: "Sales", icon: CircleDollarSign, path: "/reports/tax" },
  { id: "cat-sales", label: "Category Wise Sales", category: "Sales", icon: TrendingUp, path: "/reports/category-sales" },
  { id: "top-items", label: "Top Selling Items", category: "Sales", icon: TrendingUp, path: "/reports/top-items" },
  { id: "customer", label: "Customer Report", category: "Customers", icon: Users2, path: "/reports/customer-sales" },
  { id: "customer-ledger", label: "Customer Ledger", category: "Customers", icon: FileText, path: "/reports/customer-ledger" },
  { id: "customer-age-wise", label: "Customer Age Wise", category: "Customers", icon: Clock, path: "/reports/customer-age-wise" },
  { id: "supplier", label: "Supplier Summary", category: "Suppliers", icon: Building2, path: "/reports/supplier-summary" },
  { id: "supplier-ledger", label: "Supplier Ledger", category: "Suppliers", icon: FileText, path: "/reports/supplier-ledger" },
  { id: "supplier-age-wise", label: "Supplier Age Wise", category: "Suppliers", icon: Clock, path: "/reports/supplier-age-wise" },
  { id: "delivery", label: "Delivery Summary", category: "Operations", icon: Truck, path: "/reports/delivery-summary" },
  { id: "delivery-person", label: "Delivery Person", category: "Operations", icon: Truck, path: "/reports/delivery-person-sales" },
  { id: "delivery-area", label: "Delivery Area", category: "Operations", icon: MapPin, path: "/reports/delivery-area-sales" },
  { id: "kitchen", label: "Kitchen Report", category: "Operations", icon: ChefHat, path: "/reports/kitchen" },
  { id: "order-summary", label: "Order Summary", category: "Operations", icon: Receipt, path: "/reports/order-summary" },
  { id: "online-orders", label: "Online Orders", category: "Operations", icon: ShoppingBag, path: "/reports/online-orders" },
  { id: "discounts", label: "Product Discounts", category: "Sales", icon: Percent, path: "/reports/discounts" },
  { id: "cash-collection", label: "Cash Collection", category: "Operations", icon: Coins, path: "/reports/cash-collection" },
  { id: "tip-pool", label: "Tip & Service Charge Pool", category: "Operations", icon: Coins, path: "/reports/tip-pool" },
  { id: "branch-comparison", label: "Branch Comparison", category: "Operations", icon: TrendingUp, path: "/reports/branch-comparison" },
  { id: "supplier-compliance", label: "Supplier Compliance", category: "Inventory", icon: Building2, path: "/reports/supplier-compliance" },
  { id: "z-report", label: "Z-Report", category: "Operations", icon: ScrollText, path: "/reports/z-report" },
  { id: "x-report", label: "X-Report", category: "Operations", icon: ScrollText, path: "/reports/x-report" },
  { id: "sales-day-book", label: "Sales Day Book", category: "Operations", icon: BookOpen, path: "/reports/sales-day-book" },
  { id: "ledger", label: "Ledger Report", category: "Accounting", icon: FileText, path: "/reports/ledger" },
  { id: "trial-balance", label: "Trial Balance", category: "Accounting", icon: Scale, path: "/reports/trial-balance" },
  { id: "profit-loss", label: "Profit & Loss", category: "Accounting", icon: TrendingUp, path: "/reports/profit-loss" },
  { id: "balance-sheet", label: "Balance Sheet", category: "Accounting", icon: Landmark, path: "/reports/balance-sheet" },
  { id: "cash-book", label: "Cash Book", category: "Accounting", icon: Banknote, path: "/reports/cash-book" },
  { id: "bank-book", label: "Bank Book", category: "Accounting", icon: Building2, path: "/reports/bank-book" },
  { id: "day-book", label: "Day Book", category: "Accounting", icon: BookOpen, path: "/reports/day-book" },
  { id: "financial-statements", label: "Financial Statements", category: "Accounting", icon: FileText, path: "/reports/financial-statements" },
  { id: "inventory", label: "Condensed Stock", category: "Inventory", icon: Boxes, path: "/reports/condensed-stock" },
  { id: "opening-stock", label: "Opening Stock", category: "Inventory", icon: PackageOpen, path: "/reports/opening-stock" },
  { id: "physical-stock", label: "Physical Stock", category: "Inventory", icon: ClipboardList, path: "/reports/physical-stock" },
];

/** @returns {string | null} */
export function resolveActiveReportId(pathname) {
  if (pathname === "/reports" || pathname === "/reports/") {
    return null;
  }
  const item = REPORT_CENTER_ITEMS.find((r) => pathname === r.path || pathname.startsWith(`${r.path}/`));
  return item?.id ?? null;
}
